import AddRoleModal from './AddRoleModal'
import EditRoleModal from './EditRoleModal'
import AddPermissionsModal from './AddPermissionsModal'
import RemoveRoleModal from './RemoveRoleModal'
import RemovePermissionModal from './RemovePermissionModal'

import { Role, PermissionMeta } from 'graphql'
import { heapEvent } from '@equipmentshare/heaper'

export function getAddRoleModal( onSuccess: () => void ) {
	return {
		component: AddRoleModal,
		label: 'Add Role',
		onSuccess,
		onXClick: () => heapEvent( 'Inventory - Add Role Modal - Click - X button', {} ),
	}
}

export function getEditRoleModal( role: Role, onDeleteClick: () => void ) {
	return {
		component: EditRoleModal,
		componentProps: { role, onDeleteClick },
		label: 'Edit Role',
		onXClick: () => heapEvent( 'Inventory - Edit Role Modal - Click - X button', {} ),
	}
}

export function getRemoveRoleModal( role: Role, onSuccess: () => void ) {
	return {
		component: RemoveRoleModal,
		componentProps: { role },
		label: 'Remove Role',
		onSuccess,
		onXClick: () => heapEvent( 'Inventory - Remove Role Modal - Click - X button', {} ),
	}
}

export function getAddPermissionsModal( role: Role ) {
	return {
		component: AddPermissionsModal,
		componentProps: { role },
		label: 'Add Permissions',
		onXClick: () => heapEvent( 'Inventory - Add Permissions to Role Modal - Click - X button', {} ),
	}
}

export function getRemovePermissionModal( role: Role, permission: PermissionMeta ) {
	return {
		component: RemovePermissionModal,
		componentProps: { role, permission },
		label: 'Remove Permission',
		onXClick: () => heapEvent( 'Inventory - Remove Permissions from Role Modal - Click - X button', {} ),
	}
}
